import useReveal from "@/hooks/useReveal";

export default function Reveal({ children, className = "", delay = 0, testId }) {
  const ref = useReveal();
  return <div ref={ref} className={`reveal ${className}`} style={{ "--reveal-delay": `${delay}ms` }} data-testid={testId}>{children}</div>;
}
